import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import { LicenseEventDTO } from "../../../clients/answeringClient";
import { getEventChipProps } from "../../utils/labels";

interface Props {
  isOpen: boolean;
  isLoading: boolean;
  events: LicenseEventDTO[];
  onClose: () => void;
}

export function LicenseEventsModal({
  isOpen,
  isLoading,
  events,
  onClose,
}: Props) {

  const grouped = events.reduce((acc, ev) => {
    const dateKey = new Date(ev.createdAt).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    if (!acc[dateKey]) acc[dateKey] = [];
    acc[dateKey].push(ev);

    return acc;
  }, {} as Record<string, LicenseEventDTO[]>);

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth variant="modal">
      <DialogTitle variant="modal">
        <HistoryEduIcon />
        Movimentações da Licença
      </DialogTitle>
      <DialogContent variant="modal">
        <Typography sx={{ mb: 2 }} color="text.secondary">
          Histórico detalhado de ações relacionadas a esta licença
        </Typography>

        {isLoading ? (
          <Box display="flex" justifyContent="center" mt={4}>
            <CircularProgress />
          </Box>
        ) : events.length === 0 ? (
          <Typography sx={{ textAlign: "center", mt: 4 }}>
            Nenhum evento encontrado.
          </Typography>
        ) : (
          <Box sx={{ maxHeight: 400, overflowY: "auto", mt: 2 }}>
            {Object.entries(grouped).map(([date, group]) => (
              <Box key={date} sx={{ mb: 3 }}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ mb: 1, color: "primary.main" }}
                >
                  {date}
                </Typography>

                <Box sx={{ border: "1px solid", borderRadius: 2, marginLeft: 2, marginRight: 1, backgroundColor: "grey.50", borderColor: "grey.200", overflow: "hidden" }}>
                  <Table size="small">
                    <TableHead sx={{backgroundColor: "grey.200"}}>
                      <TableRow>
                        <TableCell>Horário</TableCell>
                        <TableCell>Ação</TableCell>
                        <TableCell>Saldo anterior</TableCell>
                        <TableCell>Quantidade</TableCell>
                        <TableCell>Novo saldo</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {group.map((ev) => (
                        <TableRow
                          key={ev.id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                            "td":{ paddingY: 1}
                          }}
                        >
                          <TableCell>
                            {new Date(ev.createdAt).toLocaleTimeString("pt-BR", {
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                            })}
                          </TableCell>
                          <TableCell>
                            <Chip
                              size="small"
                              {...getEventChipProps(ev.eventType)}
                            />
                          </TableCell>
                          <TableCell>{ev.prevQuantityAssigned}</TableCell>
                          <TableCell>{ev.quantity}</TableCell>
                          <TableCell>{ev.newQuantityAssigned}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions variant="modal" sx={{ justifyContent: "end" }}>
        <Button variant="outlined" color="error" onClick={onClose}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
